import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { SavedBrokersApi } from "@freightsimple/generated-dashboard-openapi-client/apis/SavedBrokersApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useSavedBrokersApi(): SavedBrokersApi {
  const { accessToken } = useAuthentication();

  return new SavedBrokersApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
